import VueApexCharts from 'vue-apexcharts'
import { formatCurrency } from '@/services/convert'
import { getChartColors } from '@/services/chart'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: ['list', 'type', 'costBasis', 'assetType'],
  data: function() {
    return {
      chartOptions: null,
      series: [],
      formatCurrency: formatCurrency,
      colors: getChartColors,
    }
  },
  created() {
    this.series = this.list.map(element => {
      return Number(isNaN(element.allocatedCost) ? 0 : element.allocatedCost)
    })
    this.chartOptions = {
      chart: {
        type: 'donut',
      },
      labels: this.list.map(element => {
        if (isNaN(this.costBasis) || this.costBasis === 0) {
          element.percent = 0
        } else {
          element.percent =
            (isNaN(element.allocatedCost)
              ? 0
              : element.allocatedCost / this.costBasis) * 100
        }
        return (
          element[this.assetType] + ' (' + element.percent.toFixed(2) + '%)'
        )
      }),
      dataLabels: {
        enabled: false,
        textAnchor: 'start',
        style: {
          colors: ['#fff'],
        },
        offsetX: 0,
        dropShadow: {
          enabled: true,
          left: 2,
          top: 2,
          opacity: 0.3,
        },
        formatter: function(val, opt) {
          return formatCurrency(opt['w']['config']['series'][opt.seriesIndex])
        },
      },
      legend: {
        show: false,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'left',
        floating: false,
        fontSize: '13px',
        fontWeight: 600,
        formatter: function(val, opt) {
          return (
            val +
            ' - ' +
            formatCurrency(opt['w']['config']['series'][opt.seriesIndex])
          )
        },
      },
      colors: getChartColors,
      tooltip: {
        enabled: true,
        style: {
          fontSize: '12px',
          fontWeight: 500,
        },
        onDatasetHover: {
          highlightDataSeries: true,
        },
        custom: function({ series, seriesIndex, dataPointIndex, w }) {
          return (
            '<div style="padding: 5px; z-index: 99; opacity: 1; position: relative; text-align: center;">' +
            '<span>' +
            w['config']['labels'][seriesIndex] +
            ' <span style="display: block;"> ' +
            formatCurrency(w['config']['series'][seriesIndex]) +
            '</span>' +
            '</span>' +
            '</div>'
          )
        },
      },
      responsive: [
        {
          breakpoint: 200,
          options: {
            chart: {
              width: '100%',
              animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 800,
                animateGradually: {
                  enabled: true,
                  delay: 150,
                },
                dynamicAnimation: {
                  enabled: true,
                  speed: 350,
                },
              },
            },
          },
        },
      ],
      plotOptions: {
        pie: {
          donut: {
            size: '0%',
          },
          expandOnClick: false,
        },
      },
    }
  },
  watch: {
    list() {
      this.series = this.list.map(element => {
        return Number(isNaN(element.allocatedCost) ? 0 : element.allocatedCost)
      })
      this.chartOptions = {
        labels: this.list.map(element => {
          if (isNaN(this.costBasis) || this.costBasis === 0) {
            element.percent = 0
          } else {
            element.percent =
              (isNaN(element.allocatedCost)
                ? 0
                : element.allocatedCost / this.costBasis) * 100
          }
          return (
            element[this.assetType] + ' (' + element.percent.toFixed(2) + '%)'
          )
        }),
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div style="padding: 5px; z-index: 99; opacity: 1; position: relative; text-align: center;">' +
              '<span>' +
              w['config']['labels'][seriesIndex] +
              ' <span style="display: block;"> ' +
              formatCurrency(w['globals']['series'][seriesIndex]) +
              '</span>' +
              '</span>' +
              '</div>'
            )
          },
        },
      }
    },
  },
}
